import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { CheckpointService } from '../../../pages/pages/checkpoints/checkpoint.service';
import { ClientsService } from '../../../pages/pages/clients/clients.service';
import { JobsService } from '../../../pages/pages/jobs/jobs.service';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';
import { ToasterService } from '../../services/toaster.service';
import { ModalDialogueService } from '../modal-dialogue/modal-dialogue.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { DIALOG_DATA, getFormattedTime } from '../../../../global.variable';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';

@Component({
  selector: 'gtapp-add-scheduled-reports',
  standalone: false,
  templateUrl: './add-scheduled-reports.component.html',
  styleUrl: './add-scheduled-reports.component.scss',
})
export class AddScheduledReportsComponent implements OnInit {
  jobTypesDataList: any = [];
  initialDataList: any = {};
  siteListData: any = [];
  contactListData: any = [];
  clientDropDownList: any = [];
  contactLookupList: any = [];

  reportStep: number = 1;

  addSites: boolean = true;

  contactForm: UntypedFormGroup = new UntypedFormGroup({
    first_name: new UntypedFormControl('', [Validators.required]),
    last_name: new UntypedFormControl('', [Validators.required]),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    mobile_number: new UntypedFormControl(null, [
      Validators.minLength(7),
      Validators.maxLength(10),
      Validators.pattern('^[0-9]*$'),
    ]),
  });

  newReportData: any = {
    site_data: [{}],
    company_data: [{}],
    contacts: [],
    mail_time: '10:00',
  };

  constructor(
    private spinnerService: LoadingSpinnerService,
    private jobService: JobsService,
    private dialogService: ModalDialogueService,
    private viewContainerRef: ViewContainerRef,
    private clientService: ClientsService,
    private checkPointService: CheckpointService,
    protected dialogueRef: DialogRef,
    @Inject(DIALOG_DATA) public dialogData: any,
    private toasterService: ToasterService,
  ) {}
  closeDialog(): void {
    this.dialogueRef.close(false);
  }
  ngOnInit(): void {
    if (this.dialogData?.detailData) {
      this.newReportData = {
        site_data: [this.dialogData?.detailData?.site_data, {}],
        company_data: [{}],
        contacts: [],
        mail_time: '10:00',
        name: this.dialogData?.detailData?.site_data?.company_name,
      };
    }
    this.searchClients('');
    this.onSiteSearch('');
    this.getjobTypes();
  }
  async getReportRecipients(siteId?: string, clientId?: string) {
    this.spinnerService.show('Fetching Contacts');
    return new Promise((resolve) => {
      let params: any = { list_contacts: 1 };
      if (siteId) params.site_id = siteId;
      if (clientId) params.company_id = clientId;

      this.clientService
        .listScheduledPatrolReprots(params)
        .subscribe((response: any) => {
          this.newReportData.contacts = response?.data || [];

          resolve(response?.data || []);
          this.spinnerService.hide();
        });
    });
  }
  getClientSiteId() {
    const sites = this.newReportData?.site_data?.filter(
      (item: any) => item?.id,
    );
    const clients = this.newReportData?.company_data?.filter(
      (item: any) => item?.id,
    );
    return [
      sites?.length === 1 ? sites[0]?.id : null,
      clients?.length === 1 ? clients[0]?.id : null,
    ];
  }
  async checkReportRecipients(template?: any) {
    let availableContacts: any = [];

    const [siteId, clientId] = this.getClientSiteId();

    if (siteId) availableContacts = await this.getReportRecipients(siteId);
    else if (clientId) {
      availableContacts = await this.getReportRecipients(clientId);
    } else {
      availableContacts = this.newReportData?.contacts;
    }
    if (!availableContacts?.length) this.openTemplate(template);
  }

  openTemplate(template: any) {
    this.newReportData.contacts = JSON.parse(
      JSON.stringify(this.newReportData?.contacts || []),
    );
    this.contactForm.reset();

    const dialogRef = this.dialogService.open(
      template,
      {},
      this.viewContainerRef,
    );
    dialogRef?.afterClosed().subscribe((res: any) => {
      if (res?.email) {
        this.newReportData?.contacts.push(res);
        this.contactListData = this.contactListData?.filter(
          (item: any) => item?.email !== res?.email,
        );
      }
      this.contactForm.reset();
    });
  }

  addScheduledReport() {
    let body: any = {
      name: this.newReportData?.name,
      mail_time: this.newReportData?.mail_time,
      contacts: this.newReportData?.contacts,
    };
    const selectedJobTypes = this.jobTypesDataList
      ?.filter((jType: any) => jType?.is_selected)
      ?.map((jType: any) => jType?.id);
    body.job_types = [...new Set(selectedJobTypes)];

    if (this.newReportData?.site_data?.length > 1) {
      body.site_data = [];
      this.newReportData?.site_data?.forEach((item: any) => {
        if (item?.id) {
          body.site_data.push({
            site_id: item?.id,
            company_id: item?.company?.id,
          });
        }
      });
    } else {
      body.company_data = [];
      this.newReportData?.company_data?.forEach((item: any) => {
        if (item?.id) {
          body.company_data.push({
            company_id: item?.id,
            site_id: null,
          });
        }
      });
    }

    this.spinnerService.show();

    this.clientService
      .createScheduledPatrolReprots(body, {})
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          // this.getScheduledReports();
          this.dialogueRef.close(true);
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 200);
  }
  editField(field: string) {
    if (field == 'site') {
      this.shiftFocus('siteId');
    }
    if (field == 'client') {
      this.shiftFocus('clientLookupId');
    }

    this.inputFocused(field);
  }
  inputFocused(field: string) {
    this.siteListData = [];
    this.clientDropDownList = [];
    setTimeout(() => {
      if (field === 'site') {
        const siteDataList = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
        this.siteListData = siteDataList?.filter(
          (site: any) =>
            !this.newReportData?.site_data?.some(
              (selectedSite: any) => selectedSite?.id === site?.id,
            ),
        );
      } else if (field === 'client') {
        this.clientDropDownList = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );

        const clientDropDownList = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
        this.clientDropDownList = clientDropDownList?.filter(
          (company: any) =>
            !this.newReportData?.company_data?.some(
              (selectedcompany: any) => selectedcompany?.id === company?.id,
            ),
        );
      }
    }, 200);
  }
  roundDateTimeToQuarterHour = (event: any) => {
    const newDate = new Date();
    const [hours, minutes] = event.target.value?.split(':') || ['0', '0'];
    newDate.setHours(parseInt(hours), parseInt(minutes), 0, 0);
    const msPerQuarter = 15 * 60 * 1000;
    const rounded = Math.round(newDate.getTime() / msPerQuarter) * msPerQuarter;
    setTimeout(() => {
      this.newReportData.mail_time = getFormattedTime(rounded);
    }, 500);
  };
  mobileNumberCheck() {
    if (!this.contactForm.value?.mobile_number) {
      this.contactForm.controls['mobile_number'].setValue(null);
      this.contactForm.controls['mobile_number'].removeValidators([
        Validators.minLength(7),
        Validators.maxLength(10),
        //Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
        Validators.pattern('^(\\+?(61|64|675)|0)?[0-9]{7,10}$'),
      ]);
    } else {
      this.contactForm.controls['mobile_number'].setValidators([
        Validators.minLength(7),
        Validators.maxLength(10),
        //Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
        Validators.pattern('^(\\+?(61|64|675)|0)?[0-9]{7,10}$'),
      ]);
    }
  }
  dupContactCheck() {
    const dupContactExists = this.newReportData?.contacts?.some(
      (contact: any) => contact?.email === this.contactForm.value?.email,
    );
    return dupContactExists;
  }
  onContactSearch(event: any) {
    if (event?.target?.value?.length > 2) {
      let params: any = { list_contacts: 1, search_str: event?.target?.value };
      const [siteId, clientId] = this.getClientSiteId();
      if (siteId) params.site_id = siteId;
      if (clientId) params.company_id = clientId;
      const alreadySelectedEmails = [
        ...new Set(
          this.newReportData?.contacts?.map((item: any) => item?.email),
        ),
      ];
      if (alreadySelectedEmails?.length)
        params.exclude_emails = JSON.stringify(alreadySelectedEmails);
      this.clientService
        .listScheduledPatrolReprots(params)
        .subscribe((response: any) => {
          if (response['status'] == 'success') {
            this.contactListData = response?.data;
          }
        });
    }
  }
  getjobTypes() {
    this.jobService.getJobParams().subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.jobTypesDataList = [];
        response.data?.forEach((jType: any) => {
          if ([0, 1, 2, 5, 6].includes(jType?.type_identity)) {
            if (this.dialogData?.detailData?.job_type_id) {
              this.jobTypesDataList.push({
                ...jType,
                is_selected:
                  this.dialogData?.detailData?.job_type_id == jType?.id,
              });
            } else {
              this.jobTypesDataList.push({ ...jType, is_selected: true });
            }
          }
        });
      }
    });
  }
  onSiteSearch(event?: any) {
    const searchString = event ? event.target.value : '';

    this.clientService
      .searchSites({
        search_str: searchString,
      })
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          const siteDataList = res?.data?.splice(0, 10);
          this.siteListData = siteDataList?.filter(
            (site: any) =>
              !this.newReportData?.site_data?.some(
                (selectedSite: any) => selectedSite?.id === site?.id,
              ),
          );
          if (!event) {
            this.initialDataList.site = JSON.parse(
              JSON.stringify(this.siteListData),
            );
          }
        }
      });
  }
  searchClients(searchStr?: any) {
    this.clientService.searchClients(searchStr).subscribe((res: any) => {
      if (res['status'] == 'success') {
        const clientDropDownList = res?.data;
        this.clientDropDownList = clientDropDownList?.filter(
          (company: any) =>
            !this.newReportData?.company_data?.some(
              (selectedcompany: any) => selectedcompany?.id === company?.id,
            ),
        );
        if (!searchStr) {
          this.initialDataList.client = JSON.parse(
            JSON.stringify(this.clientDropDownList),
          );
        }
      }
    });
  }
  onClientSearch(event: any) {
    if (
      event.target.value.length === 3 ||
      (event.target.value.length > 3 && this.clientDropDownList?.length)
    ) {
      this.searchClients(event.target.value);
    }
  }
}
